import React, { useState } from "react";
import {
  ListSubheader,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import {
  VolunteerActivism as VolunteerActivismIcon,
  Work as WorkIcon,
  WorkspacePremium as WorkspacePremiumIcon,
  TempleBuddhist as TempleBuddhistIcon,
  Flare as FlareIcon,
  AttachMoney as AttachMoneyIcon,
  Language as LanguageIcon,
  Fastfood as FastfoodIcon,
  LocalBar as LocalBarIcon,
  SmokingRooms as SmokingIcon,
  BrightnessLow,
  Groups as GroupsIcon,
  Label,
  Public,
  GpsFixed
} from "@mui/icons-material";
import { IoInformationCircle } from "react-icons/io5";
import AppliedFiltersRenderer from "../common/utilities/AppliedFiltersRenderer";
import { intialFilterState } from "../../services/profile";
import { FilterOptionsRenderer } from "../common/utilities/FilterOptionsRenderer";
import MobileFilterRenderer from "../common/utilities/MobileFilterOptionsRenderer";
import { SELECT_ALL_FILTER } from "../constants/filters";

const ProfileFilters = ({ applyProfileFilter, filterState, setFilterState, appliedFilters, resetSearchText }) => {
  const [searchQuery, setSearchQuery] = useState({});
  const [expandedFilter, setExpandedFilter] = useState({});  
  const [currentSelectedFilter, setCurrentSelectedFilter]=useState("");  

  // if applied filters have changed means api call was made, in this case we will minimize the filters
  React.useEffect(() => {
    setExpandedFilter({});
    setCurrentSelectedFilter("");
  }, [appliedFilters])

  const isMobile = useMediaQuery("(max-width: 768px)");

  const toggleFilterExpand = (filterName) => {
    setExpandedFilter((prevState) => ({
      ...prevState,
      [filterName]: !prevState[filterName],
    }));
  };

  const handleSearchChange = (filterName, value) => {
    setSearchQuery((prevState) => ({ ...prevState, [filterName]: value }));
  };

  const handleCheckboxChange = (filterName, option) => {
    var updatedFilters =[];
    if(option === SELECT_ALL_FILTER) {
      // check if user is trying to select or deselect option "select all"
      var allOptionsSelected = filterState[filterName].selectedCount === filterState[filterName].filters.length;
      if(allOptionsSelected) {
        updatedFilters = filterState[filterName].filters.map((item) => { return { ...item, checked: false } });
      } else  {
        updatedFilters = filterState[filterName].filters.map((item) => { return { ...item, checked: true } });
      }
    } else {
        updatedFilters = filterState[filterName].filters.map((item) =>
        item.label === option.label ? { ...item, checked: !item.checked } : item
      );
    }
  
    const selectedCount = updatedFilters.filter((item) => item.checked).length;
  
    const updatedFilterState = {
      ...filterState,
      [filterName]: {
        ...filterState[filterName],
        filters: updatedFilters,
        selectedCount,
      },
    };
  
    setFilterState(updatedFilterState);
  };
  // Reset individual filter
	const resetIndividualFilter = (filterName) => {
    const isSelectAllEnabled = filterState[filterName].enableSelectAll;
		// if filter option has select all, then reset means set all options as selected.
    const updatedFilters = filterState[filterName].filters.map((item) => ({
			...item,
			checked: isSelectAllEnabled,
		}));

		const updatedFilterState = {
			...filterState,
			[filterName]: {
				...filterState[filterName],
				filters: updatedFilters,
				selectedCount: isSelectAllEnabled ? updatedFilters.length : 0,
			},
		};

		setFilterState(updatedFilterState);
	};

  const resetFilters = () => {
    setFilterState(intialFilterState());
    resetSearchText();
  };

  return (
    <div style={{ width: "100%" }}>
      <div style={{ marginTop: 10 }}>
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <ListSubheader style={{ padding: 0, color: "#000" }} component="div">
              <span className="font-medium text-lg">Applied Filters</span>
            </ListSubheader>
            <Tooltip title="Shows the list of filters applied.">
              <div className="cursor-pointer text-xl">
                <IoInformationCircle />
              </div>
            </Tooltip>
          </div>
          <AppliedFiltersRenderer 
            filters={filterState} 
						resetIndividualFilter={resetIndividualFilter}
						onClickAction={ isMobile ? setCurrentSelectedFilter : toggleFilterExpand}
          />
        </div>
      </div>
      {
        isMobile  ? (
          <MobileFilterRenderer
            filterState={filterState}
            setFilterState={setFilterState}
            handleCheckboxChange={handleCheckboxChange}
            applyProfileFilter={applyProfileFilter}
            resetFilters={resetFilters}
            currentSelectedFilter={currentSelectedFilter}
            setCurrentSelectedFilter={setCurrentSelectedFilter}
            searchQuery={searchQuery}
            handleSearchChange={handleSearchChange}
          />   
        ) : (
          <FilterOptionsRenderer
            toggleFilterExpand={toggleFilterExpand}
            expandedFilter={expandedFilter}
            filterState={filterState}
            setFilterState={setFilterState}
            getFilterIcon={getFilterIcon}
            searchQuery={searchQuery}
            handleSearchChange={handleSearchChange}
            handleCheckboxChange={handleCheckboxChange}
            applyProfileFilter={applyProfileFilter}
            resetFilters={resetFilters}
            />
        )
      }
    </div>
  );
};

const getFilterIcon = (filterKey) => {
  switch (filterKey) {
    case "maritalStatusFilterState":
      return <VolunteerActivismIcon />;
    case "occupationFilterState":
      return <WorkIcon />;
    case "annualIncomeFilterState":
      return <AttachMoneyIcon />;
    case "casteFilterState":
      return <TempleBuddhistIcon />;
    case "qualificationFilterState":
      return <WorkspacePremiumIcon />;
    case "nakshatraFilterState":
      return <FlareIcon />;
    case "rashiFilterState":
      return <BrightnessLow />;
    case "motherTongueFilterState":
      return <LanguageIcon />;
    case "foodHabitsFilterState":
      return <FastfoodIcon />;
    case "drinkingHabitsFilterState":
      return <LocalBarIcon />;
    case "smokingHabitsFilterState":
      return <SmokingIcon />;
    case "NRIFilterState":
      return <FlightTakeoffIcon />;
    case "gotraFilterState":
      return <GroupsIcon />;
    case "stateFilterState":
      return <GpsFixed />;
    case "countryFilterState":
      return <Public />;
    default:
      return <Label/>;
  }
};

export default ProfileFilters;
